// A clean page can be destroyed while its close beacon cannot reach the
// restarting backend. Remember only those explicit clean closes in this tab.
// Do not reuse window IDs: duplicated tabs must always have independent leases.
const KEY = 'ks-release-clean-closed-windows-v1';
const valid = id => typeof id === 'string' && /^[a-f0-9-]{36}$/.test(id);

export function createCleanWindowRetirement(storage) {
  const read = () => {
    try {
      const ids = JSON.parse(storage?.getItem(KEY) || '[]');
      return Array.isArray(ids) ? [...new Set(ids.filter(valid))] : [];
    } catch { return []; }
  };
  const write = ids => {
    try {
      if (ids.length) storage?.setItem(KEY, JSON.stringify(ids));
      else storage?.removeItem(KEY);
    } catch { /* Storage unavailable: keep the existing fail-closed behavior. */ }
  };
  return {
    remember(id) { if (valid(id)) write([...new Set([...read(), id])]); },
    async retire(currentId, close) {
      for (const id of read()) {
        if (id === currentId) continue; // Never retire the executing document.
        try {
          if (await close(id)) write(read().filter(candidate => candidate !== id));
        } catch { /* Keep the explicit close for the next successful poll. */ }
      }
    }
  };
}
